export const FETCH_SIGNIN_INITIATED = 'FETCH_SIGNIN_INITIATED';
export const FETCH_SIGNIN_SUCCEEDED = 'FETCH_SIGNIN_SUCCEEDED';
export const FETCH_SIGNIN_FAILED = 'FETCH_SIGNIN_FAILED';
export const FETCH_PASSWORD_RESET_INITIATED = 'FETCH_PASSWORD_RESET_INITIATED';
export const FETCH_PASSWORD_RESET_SUCCEEDED = 'FETCH_PASSWORD_RESET_SUCCEEDED';
export const FETCH_PASSWORD_RESET_FAILED = 'FETCH_PASSWORD_RESET_FAILED';
export const FETCH_SIGNOUT_INITIATED = 'FETCH_SIGNOUT_INITIATED';
